
namespace TerminalApp {

    export class Assistant {
        container = document.createElement("div");
        constructor() {
            this.container.classList.add("assistant");
            //close button
            var close_button = this.container.appendChild(document.createElement("div"))
            close_button.classList.add("close");
            close_button.innerHTML = "X";
            close_button.addEventListener("click", () => {
                this.close();
            });

        }

        close() {
            this.container.style.display = "none";
        }

    }
}